var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title:
          _vm.note.title +
          " - " +
          _vm.$moment(_vm.note.customDate).format("MM/DD/YYYY"),
        "header-bg-variant": "success",
        "header-text-variant": "light",
        size: "lg",
        visible: true,
        centered: ""
      },
      on: { hide: _vm.modalClose, ok: _vm.updateNote },
      scopedSlots: _vm._u([
        {
          key: "modal-header-close",
          fn: function() {
            return [_c("h4", [_vm._v("X")])]
          },
          proxy: true
        },
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "b-button",
                {
                  attrs: { variant: "secondary", size: "sm" },
                  on: { click: _vm.modalClose }
                },
                [_vm._v("\n        Cancel\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: {
                    disabled: !_vm.isAllowedToCreateOrEditPerson,
                    variant: "primary",
                    size: "sm"
                  },
                  on: { click: _vm.updateNote }
                },
                [_vm._v("\n        Update\n      ")]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "personPage" },
        [
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    "label-class": "addpersonlabel",
                    label: "Date",
                    "label-for": "date",
                    horizontal: false
                  }
                },
                [
                  _c("datepicker", {
                    attrs: {
                      name: "date",
                      "input-class": "form-control-lg",
                      "initial-view": "day",
                      placeholder: "Select Date",
                      format: this.$dateFormatter,
                      "disabled-dates": { from: new Date() },
                      "clear-button": ""
                    },
                    model: {
                      value: _vm.note.customDate,
                      callback: function($$v) {
                        _vm.$set(_vm.note, "customDate", $$v)
                      },
                      expression: "note.customDate"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Title",
                    "label-class": "addpersonlabel",
                    "label-for": "title"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: { size: "lg", type: "text", name: "title" },
                    model: {
                      value: _vm.note.title,
                      callback: function($$v) {
                        _vm.$set(_vm.note, "title", $$v)
                      },
                      expression: "note.title"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                { attrs: { label: "Type" } },
                [
                  _c("v-select", {
                    attrs: {
                      options: _vm.noteTypes,
                      label: "title",
                      reduce: function(noteType) {
                        return noteType.value
                      },
                      placeholder: "Type to Search"
                    },
                    model: {
                      value: _vm.note.noteType,
                      callback: function($$v) {
                        _vm.$set(_vm.note, "noteType", $$v)
                      },
                      expression: "note.noteType"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("b-form-textarea", {
                staticClass: "mt-3",
                attrs: { rows: "10", placeholder: "Enter Note", name: "note" },
                model: {
                  value: _vm.note.note,
                  callback: function($$v) {
                    _vm.$set(_vm.note, "note", $$v)
                  },
                  expression: "note.note"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { key: _vm.componentKey, attrs: { md: "6" } },
            [
              _c("ShareNoteList", {
                attrs: {
                  noteId: _vm.note.id,
                  noteOrganizationOwner: _vm.note.organizationOwner.id,
                  personId: _vm.note.person
                }
              }),
              _vm._v(" "),
              _c(
                "b-card",
                { attrs: { "no-body": "" } },
                [
                  _c("b-card-body", [
                    _c("p", { staticClass: "card-text" }, [
                      _c(
                        "small",
                        {
                          staticClass:
                            "text-muted text-uppercase font-weight-bold"
                        },
                        [_vm._v("First Recorded")]
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("small", { staticClass: "text-muted" }, [
                        _c("b", [_vm._v(" on: ")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("unixToHuman")(_vm.note.createdAt / 1000)
                            ) +
                            "\n              "
                        ),
                        _vm._.isObject(_vm.note.createdBy)
                          ? _c("div", [
                              _c("b", [_vm._v(" by: ")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._.get(
                                      _vm.note,
                                      "createdBy.emailAddress",
                                      ""
                                    )
                                  ) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "card-text" }, [
                      _c(
                        "small",
                        {
                          staticClass:
                            "text-muted text-uppercase font-weight-bold"
                        },
                        [_vm._v("Last Updated")]
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("small", { staticClass: "text-muted" }, [
                        _c("b", [_vm._v(" on: ")]),
                        _vm._v(
                          " " + _vm._s(_vm.getUpdatedAt) + "\n              "
                        ),
                        _vm._.isObject(_vm.note.updatedBy)
                          ? _c("div", [
                              _c("b", [_vm._v(" by: ")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._.get(
                                      _vm.note,
                                      "updatedBy.emailAddress",
                                      ""
                                    )
                                  ) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "card-text" }, [
                      _c(
                        "small",
                        {
                          staticClass:
                            "text-muted text-uppercase font-weight-bold"
                        },
                        [_vm._v("Current Record Owner")]
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("small", { staticClass: "text-muted" }, [
                        _c("b", [_vm._v(" by: ")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._.get(_vm.note, "organizationOwner.title")
                            ) +
                            " "
                        )
                      ])
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31c97e5e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31c97e5e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/ViewNoteModal.vue
// module id = 1588
// module chunks = 0